import {Namespace} from './core/namespace.js';
import {Config} from './core/config.js';
import {Notification} from './core/notification.js';
import {DOM} from './core/dom.js';
import {Request} from './core/request.js';
import {JQueryRequest} from './core/jqueryrequest.js';
import {Location} from './location/location.js';
import {Tool} from './core/tool.js';
import {IntlPtBr} from './core/intl-ptbr.js';

const ASF = {

  namespace: Namespace,
  config: Config,
  notification: Notification,
  dom: DOM,
  request: Request,
  jqueryrequest: JQueryRequest,
  tool: Tool,
  intl: IntlPtBr,

  location: Location,

  init () {
    $$.config.load();
    $$.notification.init();
  }

};

window.$$ = window.ASF = ASF;

$$.init();